import React from 'react';
import { Outlet } from 'react-router-dom';

export const SocietesRoot: React.FunctionComponent = function () {
    return <Outlet />;
};

export default SocietesRoot;
